import { render, staticRenderFns } from "./RecipeCard.vue?vue&type=template&id=27b046c4&scoped=true&"
import script from "./RecipeCard.vue?vue&type=script&lang=ts&"
export * from "./RecipeCard.vue?vue&type=script&lang=ts&"
import style0 from "./RecipeCard.vue?vue&type=style&index=0&id=27b046c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b046c4",
  null
  
)

export default component.exports